import React from 'react';
import './PublicHeader.css';

const PublicHeader = ({ onLogin, onSignUp }) => {
  return (
    <header className="unauth-header">
      <div className="unauth-header-inner">
        <div className="unauth-logo">
          <a href="/" aria-label="Home">
            <img className="brand-logo-img" src="/logo.png" alt="VirtuLingu" title="VirtuLingu" />
          </a>
        </div>
        <div className="unauth-auth-buttons">
          <button 
            className="unauth-button unauth-login-button" 
            onClick={onLogin}
          >
            Sign In
          </button>
          <button 
            className="unauth-button unauth-signup-button" 
            onClick={onSignUp || onLogin}
          >
            Sign Up
          </button>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
